import React = require('react')
import {Col, Row} from 'react-bootstrap';

export const NextSteps = () => {
  const items = [
    {
      icon: 'tick.svg',
      content: 'All the information you selected  previously will be populated.',
    },
    {
      icon: 'checkmark.svg',
      content: 'Click through the journey to return to your last point.',
    },
    {
      icon: 'checklist.svg',
      content: 'Please check to make sure all the information is still correct.',
    },
  ]

  return (
    <div className="next-steps">
      {
        items.map((item, i) => {
          return (
            <div className="next-steps-item" key={i}>
              <div className="next-steps-icon-wrapper">
                <img src={require(`../../../../../images/icons/${item.icon}`)} />
              </div>
              <div className="next-steps-content">
                {item.content}
              </div>
            </div>
          )
        })
      }
    </div>
  )
}
